module.exports = __webpack_public_path__ + "img/smirk.7a6e0bef.png";